export enum LocaleEnum {
  EN = "en-us",
  FR = "fr-fr",
  TH = "th-th",
  CN = "zh-cn",
  JP = "ja-jp",
  RU = "ru-ru",
}
